import * as React from 'react'
import { useCallback, useState } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { NotesDrawerProps } from './typings'
import { ViewNotesModal } from '@user/components/Notes/ViewNotesModal/ViewNotesModal'
import { AddNoteDrawer } from '@user/components/Notes'
import { EditNoteDrawer } from '@user/components/Notes/EditNoteDrawer/EditNoteDrawer'
import { useLoadEntityLocationsOnMount } from '@user/store/entityLocations'

export const NotesDrawer: React.FC<NotesDrawerProps> = (props) => {
  const {
    lead,
    notesDrawerOpen,
    onCloseNotesDrawer,
    viewNotesModalOpen,
    hideViewNoteModal,
    canUpdate,
    onOpenNotesDrawer,
    showViewNoteModal,
  } = props

  const { id, externalLocationId } = lead
  const [backToNotes, setBackToNotes] = useState<boolean>(false)
  const [noteId, setNoteId] = useState<number>(-1)
  const [editNoteDrawerOpen, setEditNoteDrawerOpen] = useState<boolean>(false)

  const onNoteAdd = useCallback(() => {
    setBackToNotes(true)
    onOpenNotesDrawer()
  }, [onOpenNotesDrawer])

  const onGoBack = useCallback(() => {
    onCloseNotesDrawer()
    if (backToNotes) {
      showViewNoteModal()
    }
  }, [backToNotes, onCloseNotesDrawer, showViewNoteModal])

  const onGoBackFromEdit = useCallback(() => {
    setEditNoteDrawerOpen(false)
    showViewNoteModal()
  }, [setEditNoteDrawerOpen, showViewNoteModal])

  const onEditNoteClose = useCallback(() => {
    setEditNoteDrawerOpen(false)
  }, [setEditNoteDrawerOpen])

  const onSetBackNotes = useCallback(
    (value: boolean, id: number) => {
      if (value) {
        hideViewNoteModal()
        setEditNoteDrawerOpen(true)
      } else {
        showViewNoteModal()
        setEditNoteDrawerOpen(false)
      }
      setNoteId(id)
    },
    [setNoteId, setEditNoteDrawerOpen, hideViewNoteModal, showViewNoteModal],
  )

  const locationsStatus = useLoadEntityLocationsOnMount(
    id,
    ENTITY_TYPES.Lead,
    viewNotesModalOpen,
  )
  return (
    <>
      <AddNoteDrawer
        entityId={id}
        externalLocationId={externalLocationId}
        entityType={ENTITY_TYPES.Lead}
        onClose={onCloseNotesDrawer}
        onGoBack={onGoBack}
        open={notesDrawerOpen}
        backToNotes={backToNotes}
      />
      <ViewNotesModal
        entityId={id}
        entityType={ENTITY_TYPES.Lead}
        onClose={hideViewNoteModal}
        open={viewNotesModalOpen}
        externalLocationId={externalLocationId}
        canUpdate={canUpdate}
        detail={lead}
        onNoteAdd={onNoteAdd}
        backToNotes={true}
        setBackToNotes={onSetBackNotes}
        locationsStatus={locationsStatus}
      />

      <EditNoteDrawer
        entityId={id}
        entityType={ENTITY_TYPES.Lead}
        noteId={noteId}
        onClose={onEditNoteClose}
        onUpdateSuccess={onEditNoteClose}
        open={editNoteDrawerOpen}
        externalLinkId={externalLocationId}
        backToNotes={true}
        onGoBack={onGoBackFromEdit}
      />
    </>
  )
}
NotesDrawer.displayName = 'NotesDrawer'
